export default "__VITE_ASSET__RYwPnsRI__"